"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "backgrounds", {
  enumerable: true,
  get: function get() {
    return _backgrounds["default"];
  }
});
var _backgrounds = _interopRequireDefault(require("./backgrounds"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }